export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10358.fdfae3e9.jpg";